"use client";

import { useTranslations } from "next-intl";

import { getBadgeConfig } from "@/shared/config/badge-config";

/**
 * Подпись статуса турнира на языке интерфейса (KAN-1010).
 *
 * Справочник бейджей хранит русскую подпись и вариант — он же фолбэк для
 * статуса, которого ещё нет в словаре `Common.tournamentStatus`.
 */
export function useTournamentStatusLabel(): (status?: string | null) => string {
  const t = useTranslations("Common.tournamentStatus");
  return (status) => {
    if (!status) return "—";
    return t.has(status) ? t(status) : getBadgeConfig("tournamentStatus", status).text;
  };
}
